import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isSkipped: false
};

const skipSecConSlice = createSlice({
    name: "skipSecCon",
    initialState,
    reducers: {
        isSkippedAdded(state, action) {
            state.isSkipped = action.payload;
        }
    }
});

export const skipSecConSelector = (state) => state.skipSecCon;

export const { isSkippedAdded } = skipSecConSlice.actions;
export default skipSecConSlice.reducer;